webpackJsonp([354],{

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanquetTaskRecordDetail_vue__ = __webpack_require__(2540);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4bbf7d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanquetTaskRecordDetail_vue__ = __webpack_require__(3284);
function injectStyle (ssrContext) {
  __webpack_require__(3282)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4bbf7d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanquetTaskRecordDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4bbf7d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanquetTaskRecordDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      detail: {
        order_code: '',
        taskid: 0,
        title: '',
        task_status: '',
        project: '',
        batch: '',
        marketid: 0,
        market: '',
        checkin_start: '',
        checkin_end: '',
        task_end_time: '',
        created_at: '',
        columns: []
      }
    };
  },

  computed: {
    taskLink: function taskLink() {
      if (!this.detail.taskid) {
        return null;
      }
      return { path: '/task/table', query: { text: this.detail.taskid } };
    },
    marketLink: function marketLink() {
      if (!this.detail.marketid) {
        return null;
      }
      return { name: '门店修改', params: { id: this.detail.marketid } };
    },
    taskText: function taskText() {
      var title = this.detail.title || '';
      var taskid = this.detail.taskid || '';
      if (title && taskid) {
        return title + '（' + taskid + '）';
      }
      return title || String(taskid || '');
    },
    basicRows: function basicRows() {
      var start = this.detail.checkin_start || '';
      var end = this.detail.checkin_end || '';
      var windowText = start || end ? start + ' ~ ' + end : '';
      return [{ label: '任务', value: this.taskText, to: this.taskLink, label2: '状态', value2: this.detail.task_status }, { label: '项目', value: this.detail.project, label2: '批次', value2: this.detail.batch }, { label: '门店', value: this.detail.market, to: this.marketLink, label2: '签到窗口', value2: windowText }, { label: '任务结束时间', value: this.detail.task_end_time, label2: '导入时间', value2: this.detail.created_at }];
    },
    columnRows: function columnRows() {
      var columns = this.detail.columns || [];
      var rows = [];
      for (var i = 0; i < columns.length; i += 2) {
        var right = columns[i + 1];
        rows.push({
          label: columns[i].label,
          value: columns[i].value,
          label2: right ? right.label : '',
          value2: right ? right.value : ''
        });
      }
      return rows;
    }
  },
  created: function created() {
    this.loadDetail();
  },

  watch: {
    '$route.params.id': function $routeParamsId() {
      this.loadDetail();
    }
  },
  methods: {
    labelCellClass: function labelCellClass(_ref) {
      var row = _ref.row,
          columnIndex = _ref.columnIndex;

      if (columnIndex === 0 && row.label || columnIndex === 2 && row.label2) {
        return 'is-label';
      }
      return '';
    },
    loadDetail: function loadDetail() {
      var _this = this;

      request.common('banquetTaskGet', this.$route.params.id).then(function (_ref2) {
        var data = _ref2.data;

        _this.detail = {
          order_code: data.order_code || '',
          taskid: data.taskid || 0,
          title: data.title || '',
          task_status: data.task_status || '',
          project: data.project || '',
          batch: data.batch || '',
          marketid: data.marketid || 0,
          market: data.market || '',
          checkin_start: data.checkin_start || '',
          checkin_end: data.checkin_end || '',
          task_end_time: data.task_end_time || '',
          created_at: data.created_at || '',
          columns: data.columns || []
        };
      });
    }
  }
});

/***/ }),

/***/ 3282:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3283);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6f8bcd8f", content, true, {});

/***/ }),

/***/ 3283:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "[data-v-e4bbf7d8] td.is-label{background:#f5f7fa;color:#303133;font-weight:600}.link-text[data-v-e4bbf7d8]{color:#409eff;text-decoration:none}.link-text[data-v-e4bbf7d8]:hover{text-decoration:underline}", "", {"version":3,"sources":["/workspace/src/views/banquet-task/pages/BanquetTaskRecordDetail.vue"],"names":[],"mappings":"AACA,8BAA8B,mBAAmB,cAAc,eAAe,CAC7E,AACD,4BAA4B,cAAc,oBAAoB,CAC7D,AACD,kCAAkC,yBAAyB,CAC1D","file":"BanquetTaskRecordDetail.vue","sourcesContent":["\n[data-v-e4bbf7d8] td.is-label{background:#f5f7fa;color:#303133;font-weight:600\n}\n.link-text[data-v-e4bbf7d8]{color:#409EFF;text-decoration:none\n}\n.link-text[data-v-e4bbf7d8]:hover{text-decoration:underline\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("新宴席管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/banquet-task/records' }}},[_vm._v("宴席任务")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("基础信息")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.basicRows,"border":"","show-header":false,"cell-class-name":_vm.labelCellClass}},[_c('el-table-column',{attrs:{"prop":"label","width":"160"}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.to)?_c('router-link',{staticClass:"link-text",attrs:{"to":scope.row.to}},[_vm._v("\n            "+_vm._s(scope.row.value)+"\n          ")]):_c('span',[_vm._v(_vm._s(scope.row.value))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"label2","width":"160"}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.to2)?_c('router-link',{staticClass:"link-text",attrs:{"to":scope.row.to2}},[_vm._v("\n            "+_vm._s(scope.row.value2)+"\n          ")]):(scope.row.label2)?_c('span',[_vm._v(_vm._s(scope.row.value2))]):_vm._e()]}}])})],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("宴席原始信息")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.columnRows,"border":"","show-header":false,"cell-class-name":_vm.labelCellClass}},[_c('el-table-column',{attrs:{"prop":"label","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.value)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"label2","width":"200"}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.label2)?_c('span',[_vm._v(_vm._s(scope.row.value2))]):_vm._e()]}}])})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/banquet-task-record-detail.c276c22c11914829a57b.js